<template>
    <div>
        <div class="col-xs-12 col-sm-6 col-md-4 agx-list-oneInRow" v-bind:style="{'height':'250px'}">
            <div>
                <div style="z-index:999;text-align:right;">
                    <span class="label label-primary" style="z-index:999;display:inline-block;">{{item.parentCategory.name}} </span> /
                    <span class="label label-info" style="z-index:999;display:inline-block;"> {{item.category.name}} </span>
                </div>
                <div style="border-bottom: 1px solid #ececec; ">
                    <div>
                        <router-link :to="{name:'articleDetail',query:{postId:item.postId}}">
                            <img style="display: inline-block; height: 80px; border-radius: 10px; box-shadow: 10px 5px 5px #ececec;"
                                 class="img-reponsive" :src="item.thumbPath" :title="item.title" v-if="item.thumbPath!==null">
                            <span v-else style="display: inline-block; font-weight: bolder; text-align: center; width: 80px; height: 80px; line-height: 80px; font-size: 60px; border: 1px solid gray; border-radius: 4px; box-shadow: 10px 5px 5px #ececec;">
                                <span v-if="item.title!==null && item.title.length>0">{{item.title[0]}}</span>
                            </span>
                        </router-link>
                    </div>
                    <div style="padding:4px;">
                        <router-link :to="{name:'articleDetail',query:{postId:item.postId}}">
                            <span style="font-weight:bolder;">{{item.title}}</span>
                        </router-link>
                    </div>
                </div>
                
                <div class="agx-post-intros-hidden" style="width:100%;">
                    <div>{{item.textMsg}}</div>
                </div>
                <div style="position: absolute; left: 0px; right: 0px; bottom: 0px;height: 24px; background: #ececec;box-shadow: 0px -10px 15px #ececec;text-align:center;">
                    <span style="color:gray;font-size:12px;">Update:{{item.zoneEditDatetime}}</span>
                </div>
            </div>
           
        </div>
    </div>
</template>
<script>
    
    export default {
        components: {
            
        },
        filters: {
            cutContent: function (txtMsg) {
                if (txtMsg === null) return;
                var length = 150;
                return txtMsg.length > length ? txtMsg.slice(0, length) + "......" : txtMsg;
            }
        },
        props: ["item","itemType"],
        data: function () {
            return {

            }
        },
        mounted: function () {

        }
    }
</script>